<ion-list class="news__list">
  <ion-list-header class="news__list__title">Neuigkeiten</ion-list-header>
  <ion-spinner *ngIf="!(news$ | async)?.length && loading$ | async" class="news__list__loading" color="primary"></ion-spinner>
  <ion-item *ngFor="let news of news$ | async" class="news__list__item" [detail]="false" (click)="handleClick(news)">
    <div class="news__list__item__wrapper">
      <div class="news__list__item__content">
        <img [src]="news | getNewsImage" alt="" class="news__list__item__avatar" />
        <p class="news__list__item__description" [innerHTML]="news.text"></p>
      </div>
      <div class="news__list__item__footer" [class.--no-footer]="news.likes.length === 0">
        <div class="news__list__item__footer__likes" (click)="toggleNewsLike($event, news)">
          <span class="news__list__item__footer__likes__count" *ngIf="news.likes.length > 0">{{ news.likes.length }}</span>
          <ion-icon
            class="news__list__item__footer__likes__icon --filled"
            *ngIf="news | isNewsLikedByMe | async; else notLiked"
            name="heart"
          ></ion-icon>

          <ng-template #notLiked>
            <ion-icon class="news__list__item__footer__likes__icon" name="heart-outline"></ion-icon>
          </ng-template>
        </div>
      </div>
    </div>
  </ion-item>
</ion-list>

<ion-infinite-scroll [disabled]="(totalPages$ | async) <= (currentPage$ | async)" (ionInfinite)="loadMoreNews($any($event))">
  <ion-infinite-scroll-content color="primary" loadingText="Laden..."></ion-infinite-scroll-content>
</ion-infinite-scroll>
